const wrapper = "_35sw1gk8fyk";

export { wrapper };
import "./chunk.task.style.linaria.module.css";
//# sourceMappingURL=chunk.task.style.js.map
